import { useEffect, useState } from 'react'
import { trainingCoursesStore } from '../services/trainingCoursesStore'

export function useTrainingCourses() {
  const [courses, setCourses] = useState(trainingCoursesStore.getAll())

  useEffect(
    () =>
      trainingCoursesStore.subscribe(() =>
        setCourses(trainingCoursesStore.getAll()),
      ),
    [],
  )

  return courses
}
